import { render, staticRenderFns } from "./image-gallery.vue?vue&type=template&id=8125bb8c&scoped=true"
import script from "./image-gallery.vue?vue&type=script&lang=js"
export * from "./image-gallery.vue?vue&type=script&lang=js"
import style0 from "./image-gallery.vue?vue&type=style&index=0&id=8125bb8c&prod&lang=css"
import style1 from "./image-gallery.vue?vue&type=style&index=1&id=8125bb8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8125bb8c",
  null
  
)

export default component.exports